import axios from '../axios'

const getCategoryList = params => {
  return axios({
    url: '/customer/recycle/product/getCategories',
    method: 'get',
    params
  })
}
const getBrandList = params => {
  return axios({
    url: '/customer/recycle/product/getBrands',
    method: 'get',
    params
  })
}
const phoneModelList = data => {
  return axios({
    url: '/customer/recycle/product/getProducts',
    method: 'post',
    data
  })
}
const searchPhoneModel = data => {
  return axios({
    url: '/customer/recycle/product/search',
    method: 'post',
    data
  })
}

const getProduct = params => {
  return axios({
    url: '/customer/recycle/product/getProduct',
    method: 'get',
    params
  })
}

const officialSubmit = data => {
  return axios({
    url: '/customer/recycle/order/official/submit',
    method: 'post',
    data
  })
}

const checkQrCode = params => {
  return axios({
    url: '/customer/recycle/promotion/checkQrCode',
    method: 'get',
    params
  })
}

export {
  getCategoryList,
  getBrandList,
  phoneModelList,
  searchPhoneModel,
  getProduct,
  officialSubmit,
  checkQrCode
}
